import { useContext, useState, useEffect, useMemo, useRef } from 'react';
import { AsgFwContext } from '../contexts';
import { GamesService } from '../../../shared/src/services/games.service';
import {
    GtmEventLocation,
    GtmEventComponent,
    GtmEventClickElement
} from '../../../shared/src/components/google-tag-manager/enums/gtm-event-enum';
import { GtmService } from '../../../shared/src/services/gtm.service';
import { useCurrentVerticalData } from '../../../shared/src/hooks/use-current-vertical-data.hook';

export const useReadMoreGames = ({ gameIds }) => {
    const GAMES_LOAD_MORE_PORTION = 56;
    const AsgFW = useContext(AsgFwContext);
    const [isMoreGamesBtnVisible, setIsMoreGamesBtnVisible] = useState(false);
    const [gamesToRender, setGamesToRender] = useState([]);
    const previousGameIdsRef = useRef([]);

    const existedGameIds = useMemo(() => {
        return Array.isArray(gameIds) && gameIds.length
            ? GamesService.filterGamesToRender(gameIds, AsgFW)
            : [];
    }, [gameIds, AsgFW]);

    useEffect(() => {
        // Check if gameIds have changed
        const gameIdsAreSame =
            previousGameIdsRef.current.length === existedGameIds.length &&
            previousGameIdsRef.current.every((id, index) => id === existedGameIds[index]);

        // Update only if gameIds have changed
        if (!gameIdsAreSame) {
            const initialRenderChunk = existedGameIds.slice(0, GAMES_LOAD_MORE_PORTION);
            setGamesToRender(initialRenderChunk);
            setIsMoreGamesBtnVisible(initialRenderChunk.length < existedGameIds.length);
            previousGameIdsRef.current = existedGameIds; // Update the previous gameIds reference
        }
    }, [existedGameIds]);
    const {
        pamGameVerticalID,
        currentVerticalType,
    } = useCurrentVerticalData();

    const loadMore = () => {
        GtmService.track({
            location: GtmEventLocation.GAME_GRID,
            component: GtmEventComponent.GAME_GRID,
            click_element: GtmEventClickElement.BUTTON,
            click_action: 'show more games',
            game_vertical_id: pamGameVerticalID,
            game_vertical_type: currentVerticalType,
        });
        const renderedAmount = gamesToRender.length;
        const newPortion = existedGameIds.slice(0, renderedAmount + GAMES_LOAD_MORE_PORTION);
        setGamesToRender(newPortion);
        setIsMoreGamesBtnVisible(newPortion.length < existedGameIds.length);
    };

    return {
        isMoreGamesBtnVisible,
        gamesToRender,
        loadMore,
    };
};
